import React from 'react';
import { teamP1 } from '../components/Data/Arabic';
import { teamP2 } from '../components/Data/English';

const OurTeam = ({lang}) => {
  return (
    <>
      <div id="teams" className="px-32 lg:px-16 md:px-14 py-10 lg:py-10 sm:px-2 lg:w-full sm:w-full">
        <div className="section mx-auto p-10 lg:p-1 sm:p-0 lg:w-[82%] sm:w-11/12 xl:max-w-[1400px] xl:mx-auto">
          <div className=" m-auto lg:p-6 p-11 sm:p-6 basis-4/5">
            <div className=" mx-auto text-center relative flex justify-center">
              <h2 className="xl:text-5xl lg:text-4xl sm:text-3xl py-8 mb-8 text-center font-black">فريقنــا</h2>
              <span className="bg-orange lg:w-30 md:w-20 w-20 sm:w-16 h-1  absolute rounded mt-24 lg:mt-28"></span>
            </div>
            <p className="font-black text-center leading-loose xl:text-3xl lg:text-2xl md:leading-10 md:text-2xl lg:px-5 xl:px-44 xl:leading-loose lg:leading-loose  px-40 lg:mb-0 md:mb-0 sm:mb-0 mt-8 md:px-10 sm:text-xl sm:px-2">
            {lang ? teamP2 : teamP1 }</p></div>
             
        </div>
      </div>
    </>
  );
}

export default OurTeam;
